<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Add Volunteer</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">Add volunteers by email. They will get email with instructions to proceed. Volunteers get special prvilage in the PayBee app to accept donations, checkin etc.</div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form" [formGroup]="form">
    <mdb-form-control class="form-fill">
        <app-mdbp-input mdbInput formControlName="email" label='User Email'></app-mdbp-input>
        <mdb-error class="form-fill-error"  *ngIf="form.controls.email.hasError('required') && form.controls.email.touched ">Please provide User Email</mdb-error>
        <mdb-error class="form-fill-error"  *ngIf="form.controls.email.hasError('pattern') && form.controls.email.touched ">Invalid User Email</mdb-error>
        <mdb-error class="form-fill-error" *ngIf="emailError">{{emailError}}</mdb-error>
    </mdb-form-control>
</div>

<div class="modal-footer paybee-modal-footer">
    <a class="btn btn-sm modal-cancel-button waves-effect waves-light" (click)="close()">Cancel</a>
    <a class="btn btn-sm modal-confirm-button waves-effect waves-light" (click)="addVolunteer()">Add</a>
</div>